import * as React from 'react';
import {authorize} from "@athena-portal/components";
import FalconHeader from "../components/navigation/FalconHeader";
import FalconFooter from "../components/navigation/FalconFooter";
import {IApplicationGuard, lazyInject, TypeDefs} from "@athena-portal/core";
import {resourcesHelper} from "@falcon/services";
import {MultiTabBroadcastEvents, StoragesKeys} from "../components/enums/enums"

interface IState {
    accountUrl: string,
    redirectUrl: string,
}

@authorize
export class MultiTabWarningPage extends React.Component<{}, IState> {

    @lazyInject(TypeDefs.ApplicationGuard)
    private readonly applicationGuard: IApplicationGuard;

    private readonly channel = new BroadcastChannel("multiTabCheck");

    private readonly isBritannia = resourcesHelper.THEME === "Britannia";

    constructor(props: {}) {
        super(props);


        this.state = {
            accountUrl: '/dashboard',
            redirectUrl: '/dashboard'
        }
        this.closeSessionAndRecoverOnOtherTabs = this.closeSessionAndRecoverOnOtherTabs.bind(this);
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="multi-tab">

                    <div className="heading">
                        <h2 className="multi-tab-headline">Your account is already open in another tab</h2>

                        <p><img src="/img/multi-tab-warn.svg" alt="Multi tab not allowed"/></p>

                        <div className="text-content">
                            <p>Using more than one tab at the same time can cause changes not to save correctly. If you continue here, you could lose any unsaved changes.</p>
                        </div>
                        <div className="d-flex flex-column align-items-start justify-content-start subheading-section">
                            <div className="button-container">
                                <button type="button" className="btn btn-primary multi-tab-btn"
                                        onClick={() => this.closeSessionAndRecoverOnOtherTabs()}>
                                    Return to other tab
                                </button>

                                <button type="button"
                                        className="btn btn-white multi-tab-btn multi-tab-btn-right"
                                        onClick={() => this.closeAllOtherSessionsAndBackToLastKnownPage()}>
                                    Continue here
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <FalconFooter />
            </React.Fragment>
        );
    }

    private readonly closeAllOtherSessionsAndBackToLastKnownPage = () => {
        this.channel.postMessage({
            type: MultiTabBroadcastEvents.REDIRECT_ALL_OTHER_TABS_EVENT,
            tabId: sessionStorage.getItem(StoragesKeys.TAB_ID)
        })
        localStorage.removeItem(this.getLockUserTabKey());
        const backRedirect = sessionStorage.getItem(StoragesKeys.BACK_REDIRECT);
        if (backRedirect) {
            window.location.assign(backRedirect);
            sessionStorage.removeItem(StoragesKeys.BACK_REDIRECT)
        } else {
            history.back();
        }
    }

    private readonly closeSessionAndRecoverOnOtherTabs = () => {
        localStorage.removeItem(this.getLockUserTabKey());
        this.channel.postMessage({
            type: MultiTabBroadcastEvents.RETURN_OTHER_TABS_TO_LAST_PAGE,
            tabId: sessionStorage.getItem(StoragesKeys.TAB_ID)
        })
        this.isBritannia ? this.redirect("https://www.britanniainsurance.co.uk/") : this.redirect("https://www.allianz.co.uk");
    }

    private getLockUserTabKey() {
        return "partyLockTabId_" + resourcesHelper.THEME + "_" + this.applicationGuard.getUser()?.name;
    }

    private readonly redirect = (redirectUrl: string) => {
        window.location.assign(redirectUrl)
    }
}
